export default __webpack_public_path__ + "static/media/1128040325514430.1855d816.jpg";